module.exports = __webpack_public_path__ + "static/himmel-und-holle-02-7b3c07d814a2e2c6077ce38e6bc34b65.jpg";